import type { CSSProperties } from "react";
import type { PaletteId } from "@shared/events";
import { PALETTE, PALETTE_ORDER } from "./palette";

/**
 * OWNED BY C1. The curated colour picker: 12 swatches, no hex input (F-207, F-301).
 * Used for tile colours and for the register accent.
 */
export function PaletteGrid({ label, value, onChange, disabled }: {
  label: string;
  value: PaletteId;
  onChange: (id: PaletteId) => void;
  disabled?: boolean;
}) {
  return (
    <div role="radiogroup" aria-label={label} className="wc-palette">
      {PALETTE_ORDER.map((id) => (
        <button
          key={id}
          type="button"
          role="radio"
          aria-checked={id === value}
          aria-label={PALETTE[id].name}
          disabled={disabled}
          className="wc-palette__swatch"
          style={{ "--sw": `var(--${id})`, "--sw-ink": `var(--${id}-ink)` } as CSSProperties}
          onClick={() => onChange(id)}
        >
          {id === value ? "✓" : ""}
        </button>
      ))}
    </div>
  );
}
